<script lang="ts">
  import * as _ from "lodash";
  import type { Storefront, StorefrontCollection } from "@shared/types/Storefront";
  import ProductCard from "@shared/svelte/Components/ProductLines/ProductCard.svelte";
  export let storefront: Storefront;

  let collections: StorefrontCollection[] = storefront.storefront_collections_attributes;
  let storefrontDistributor = storefront.distributor || {};
  $: {
    storefront = storefront;
    collections = storefront.storefront_collections_attributes;
    storefrontDistributor = storefront.distributor || {};
  }

  function doScroll(collection: any, dir: any) {
    let fig = document.querySelector(`.fizz-scroll-row-${collection.id} .product-result-tile-fizz`);
    if (!fig) {
      return;
    }
    let width = fig.clientWidth * dir;
    let container = document.querySelector(`.fizz-scroll-row-${collection.id}`);
    if (!container) {
      return;
    }
    container.scrollBy({ left: width, behavior: "smooth" });
  }
</script>

{#each collections as collection}
  {#if collection.enabled}
    {#if collection.title}
      <h2 class="fizz-heading-2 fizz-stack-24 fizz-text-center" id="product-card-title">
        {collection.title}
      </h2>
    {/if}
    <section id="collections" class="fizz-carousel fizz-stack-24">
      {#if collection.storefront_product_cards_attributes.length > 4}
        <button
          class="fizz-prev-small cursor-pointer show--md"
          on:click={() => doScroll(collection, -1)}><span>Previous</span></button
        >
      {/if}

      <ul class="fizz-scroll-row-{collection.id} fizz-carousel-items">
        {#each collection.storefront_product_cards_attributes as productCard, index (productCard.id)}
          <li
            class="product-result-tile-fizz"
            id={`product_line_${productCard.product_line.id}`}
            product-line-id={productCard.product_line.id}
          >
            <ProductCard
              distributorOverride={{
                id: storefrontDistributor.id,
                name: storefrontDistributor.name,
              }}
              productLine={productCard.product_line}
              userIsAdmin={false}
              {index}
              hidePrice={true}
            />
          </li>
        {/each}
      </ul>

      {#if collection.storefront_product_cards_attributes.length > 4}
        <button
          class="fizz-next-small cursor-pointer show--md"
          on:click={() => doScroll(collection, 1)}><span>Next</span></button
        >
      {/if}
    </section>
  {/if}
{/each}
